import { useState, useEffect } from "react";
import Navbar from "../components/HomePage/Navbar";
import Hero from "../components/HomePage/Hero";
import Footer from "../components/HomePage/Footer";
import FAQ from "../components/HomePage/FAQ";
import VideoBackground from "../components/HomePage/VideoBackground";
import IntroOutro from "../components/HomePage/IntroOutro";
import Creators from "../components/HomePage/Creators";
import DemoNow from "../components/HomePage/DemoNow";
import CTA from "../components/HomePage/CTA";
import videoBackgroundWebm from "./../assets/AG_BG_Effects.webm";
import videoBackgroundMp4 from "./../assets/AG_BG_Effects.mp4";
import posterImage from "./../assets/poster.png";
import loveEmoji from "./../assets/love-emoji-3d 1.png";
import micEmoji from "./../assets/mic-3d 1.png";
import NewView from "../components/HomePage/NewView";

const HomePage = () => {
  const [videoEnded, setVideoEnded] = useState(false);
  const [startTyping, setStartTyping] = useState(false);
  const [isVideoReady, setIsVideoReady] = useState(false);

  const handleVideoEnd = () => {
    setVideoEnded(true);
  };

  const handleVideoAlmostEnd = () => {
    setStartTyping(true);
  };

  const handleVideoReady = () => {
    setIsVideoReady(true);
  };

  return (
    <div className="w-full bg-black overflow-x-hidden">
      <section className="h-[500px] sm:h-[600px] md:h-[700px] lg:h-[800px] xl:h-[850px] 2xl:h-[900px] relative w-full bg-black">
        {/* Decorative Emojis - visible on all screens with floating animation */}
        <img
          src={loveEmoji}
          alt="Love emoji"
          className="absolute left-2 sm:left-4 md:left-8 lg:left-16 xl:left-24 2xl:left-32 top-1/4 sm:top-1/3 w-16 h-16 sm:w-20 sm:h-20 md:w-32 md:h-32 lg:w-56 lg:h-56 xl:w-64 xl:h-64 2xl:w-80 2xl:h-80 z-[3] pointer-events-none float-animation"
          style={{ animationDelay: '0s' }}
        />
        <img
          src={micEmoji}
          alt="Mic emoji"
          className="absolute right-2 sm:right-4 md:right-8 lg:right-8 xl:right-12 2xl:right-16 top-[35%] sm:top-[40%] w-16 h-16 sm:w-20 sm:h-20 md:w-32 md:h-32 lg:w-56 lg:h-56 xl:w-64 xl:h-64 2xl:w-80 2xl:h-80 z-[3] pointer-events-none float-animation"
          style={{ animationDelay: '2s' }}
        />

        {/* Video Background - bottom layer */}
        <VideoBackground
          videoSrcWebm={videoBackgroundWebm}
          videoSrcMp4={videoBackgroundMp4}
          onVideoEnd={handleVideoEnd}
          onAlmostEnd={handleVideoAlmostEnd}
          onVideoReady={handleVideoReady}
        />

        {/* Overlay Gradient - middle layer */}
        <div className="absolute inset-0 z-[2]">
          <div
            className="absolute top-0 left-0 w-full h-full pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse 1200px 550px at center, transparent 50%, #000000 90%)",
            }}
          />
        </div>

        {/* Content - top layer */}
        <div className="relative z-10">
          <Navbar />
          <Hero startTyping={startTyping} isVideoReady={isVideoReady} />
        </div>
      </section>

      <CTA />
      <NewView />
      <DemoNow />
      <Creators />
      <IntroOutro />
      <FAQ />
      <Footer />
    </div>
  );
};

export default HomePage;
